import TabCardImage from '@assets/images/tab-card.png';
import { ImageURISource, Platform } from 'react-native';
import { useCallback, useState } from 'react';

// Next.js resolves image imports as { src, height, width, ... } while RN
// expects a require() asset ID. We use import + .src for web, require for
// native.
const DEFAULT_TAB_CARD_IMAGE: ImageURISource =
  Platform.OS === 'web'
    ? { uri: (TabCardImage as unknown as { src: string }).src }
    : (require('@assets/images/tab-card.png') as ImageURISource);

interface UseTabCardImageResult {
  onImageLoadError: () => void;
  source: ImageURISource;
}

export const useTabCardImage = (imageUrl?: string): UseTabCardImageResult => {
  const [source, setSource] = useState<ImageURISource>(
    imageUrl ? { uri: imageUrl } : DEFAULT_TAB_CARD_IMAGE,
  );

  const onImageLoadError = useCallback(() => {
    setSource(DEFAULT_TAB_CARD_IMAGE);
  }, []);

  return { onImageLoadError, source };
};
